import AppFormCreate from "@/controllers/application_form/app-form-create";

export default {
  extends: AppFormCreate,

  methods: {
    setAppType() {
      let defaultArr = [
        {
          id: 0,
          text: "Select Form Type",
        }
      ];
      let typeArray = Object.keys(this.appTypeText)
        .filter(key => parseInt(key) !== 2)
        .map(key => ({
          id: parseInt(key),
          text: this.appTypeText[key]
        }));
      this.appTypeArr = defaultArr.concat(typeArray);
    },
  }
}
